import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiCustom from "../../utils/ApiCustom";

export const fetchRoles = createAsyncThunk("roles/fetchRoles", async () => {
  const response = await apiCustom.get("/role-shows");
  return response.data?.data?.data?.roles;
});
export const fetchPermissions = createAsyncThunk(
  "roles/fetchPermissions",
  async () => {
    const response = await apiCustom.get("/permission-shows");
    return response.data?.data?.data;
  }
);
export const fetchPermissionsCate = createAsyncThunk(
  "roles/fetchPermissionsCate",
  async () => {
    const response = await apiCustom.get("/permissions-show");

    return response.data?.data?.permission;
  }
);

export const saveRole = createAsyncThunk(
  "roles/saveRole",
  async (newPost, { rejectWithValue }) => {
    try {
      const response = await apiCustom.post("/role-create", newPost, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const fetchRoleById = createAsyncThunk(
  "roles/fetchRoleById",
  async (id) => {
    const response = await apiCustom.get(`/role-show?id=${id}`);
    return response.data?.data;
  }
);

export const updateRole = createAsyncThunk(
  "roles/updateRole",
  async (roleItem, { rejectWithValue }) => {
    try {
      const response = await apiCustom.put(`/role-update`, roleItem);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  }
);
export const deleteRole = createAsyncThunk(
  "roles/deleteRole",
  async (data, { rejectWithValue }) => {
    try {
      const response = await apiCustom.delete(
        `/role-destroy`,
        { data },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return { response };
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  }
);
//  phân quyền cho danh mục
export const savePermision = createAsyncThunk(
  "roles/savePermision",
  async (data, { rejectWithValue }) => {
    try {
      const response = await apiCustom.post("/permissions-create", data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const updatePermission = createAsyncThunk(
  "roles/updatePermission",
  async ({ id, dataUpdate }, { rejectWithValue }) => {
    try {
      const response = await apiCustom.put(
        `/permissions-update/${id}`,
        dataUpdate
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  }
);
export const deletePermission = createAsyncThunk(
  "roles/deletePermission",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiCustom.delete(`/permissions-delete/${id}`, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      return { response };
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  }
);
const rolesSlice = createSlice({
  name: "roles",
  initialState: {
    roles: [],
    permissions: [],
    permissionsCate: [],
    selectedRole: null,
    status: "idle",
    error: null,
  },
  reducers: {
    setPermissions: (state, action) => {
      state.permissions = action.payload;
    },
    setPermissionsCate: (state, action) => {
      state.permissionsCate = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPermissionsCate.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchPermissionsCate.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.permissionsCate = action.payload;
      })
      .addCase(fetchRoles.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchRoles.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.roles = action.payload;
      })
      .addCase(fetchRoleById.fulfilled, (state, action) => {
        state.selectedRole = action.payload;
      })
      .addCase(fetchPermissions.fulfilled, (state, action) => {
        state.permissions = action.payload;
      })

      .addCase(fetchRoles.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Add role
      .addCase(saveRole.fulfilled, (state) => {
        state.status = "idle";
      })
      .addCase(savePermision.fulfilled, (state) => {
        state.status = "idle";
      })
      // Update role
      .addCase(updateRole.fulfilled, (state) => {
        state.status = "idle";
      })
      .addCase(updatePermission.fulfilled, (state) => {
        state.status = "idle";
      })
      // Delete role
      .addCase(deleteRole.fulfilled, (state) => {
        state.status = "idle";
      })
      .addCase(deletePermission.fulfilled, (state) => {
        state.status = "idle";
      });
  },
});
export const { setPermissions, setPermissionsCate } = rolesSlice.actions;
export default rolesSlice.reducer;
